import React from 'react'
import { Divider, Icon, Tooltip, Typography } from 'shared/ui'
import { numberFormat } from 'shared/lib'
import { type IResponseBillingDepositPricePreview } from 'entities/Billing/api/types.ts'
import { getTaxes } from 'entities/Billing/ui/PriceInfo/utils/getTaxes.ts'
import styles from './styles.module.scss'

export const PaymentInfo = ({
  depositPricePreview,
}: {
  depositPricePreview: IResponseBillingDepositPricePreview
}) => {
  const taxes = getTaxes(depositPricePreview)
  return (
    <div className={styles.wrap}>
      <Row
        title={'Brand vetting fee (one-time)'}
        tooltipLabel={'This is a one-time carrier fee for submitting it for the second vetting'}
        cents={depositPricePreview?.total_excluding_tax}
      />

      <Divider sx={{ borderColor: 'var(--black-20)' }} />
      {taxes && (
        <>
          <Row title={taxes.title} value={taxes?.total} />
          <Divider sx={{ borderColor: 'var(--black-20)' }} />
        </>
      )}
      <div className={styles.rowTitle}>
        <div className={styles.left}>
          <Typography ariaLabel={'title'} variant={'body-lg-medium'}>
            Total
          </Typography>
        </div>

        <Typography ariaLabel={'value'} variant={'body-lg-medium'}>
          {numberFormat({
            value: depositPricePreview?.total / 100,
            currency: 'USD',
            maximumFractionDigits: 2,
          })}
        </Typography>
      </div>
    </div>
  )
}

const Row = ({
  cents,
  tooltipLabel,
  title,
  value,
}: {
  cents?: number
  value?: string
  tooltipLabel?: string
  title: string
}) => (
  <div className={styles.row}>
    <div className={styles.left}>
      <Typography ariaLabel={'title'} variant={'body-md-regular'}>
        {title}
      </Typography>
      {tooltipLabel && (
        <Tooltip label={tooltipLabel} placement={'top'} breakWord>
          <Icon
            padding={2}
            fontSize={12}
            icon={'questionFull'}
            color={'var(--content-neutral-primary)'}
          />
        </Tooltip>
      )}
    </div>

    <Typography ariaLabel={'value'} variant={'body-md-regular'}>
      {cents !== undefined
        ? numberFormat({
            value: cents / 100,
            currency: 'USD',
            maximumFractionDigits: 2,
          })
        : value}
    </Typography>
  </div>
)
